import { ready } from '../utils/readyinit';
import initCartPage from '../sections/cart/initCartPage';

ready(() => {
  initCartPage();
});
